module.exports = __webpack_public_path__ + "img/focus.401df0f5.webp";